import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AlertService, AlertType } from 'src/app/shared/services/alert.service';
import { Masks, MaskService } from 'src/app/shared/services/mask.service';
import { MedicalProcedureStruct } from 'src/app/shared/services/structs/medical-record/medical-procedure.struct';
import { KitWithItemsStruct } from 'src/app/shared/services/structs/pharmacy/kit-with-items.struct';
import { KitItemsModalComponent } from '../../kit-items-modal/kit-items-modal.component';
import { dateHourInCrescentOrderValidator } from 'src/app/shared/custom-validators/date-hour-form-array-order.validator';
import { ObservationScheduling } from 'src/app/shared/services/models/bed/observation-scheduling.model';
import { FrequencyEnum } from 'src/app/shared/enum/medical-record/frequency.enum';
import { MedicalProcedureCheckStruct } from 'src/app/shared/services/structs/orchestrator-patient/medical-procedure-check.struct';
import { KitMultiselectStruct } from 'src/app/shared/services/structs/pharmacy/kit-multiselect.struct';
import { ItemService } from 'src/app/shared/services/API/pharmacy/Item.service';
import { KitService } from 'src/app/shared/services/API/pharmacy/kit.service';
import { ItemModel } from 'src/app/shared/services/models/pharmacy/item.model';
import { MaterialItemKitRequests } from 'src/app/shared/services/requests/pharmacy/request-material.request';
import { StatusSchedulingEnum } from 'src/app/shared/enum/medical-record/status-scheduling.enum';
import { minOneHourDifferenceValidator } from 'src/app/shared/custom-validators/min-one-hor-difference.validator';

@Component({
    selector: 'app-procedure-scheduling-modal',
    templateUrl: './procedure-scheduling-modal.component.html',
    styleUrls: ['./procedure-scheduling-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ProcedureSchedulingModalComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, 
    public dialog: MatDialog, 
    public matDialogRef: MatDialogRef<ProcedureSchedulingModalComponent>,
    private formBuilder: FormBuilder,
    private maskService: MaskService,
    private alertService: AlertService,
    public itemService: ItemService,
    public kitService: KitService,
  ) { }

  public frequencyEnum: typeof FrequencyEnum = FrequencyEnum;
  public statusSchedulingEnum: typeof StatusSchedulingEnum = StatusSchedulingEnum;
  
  public model: FormGroup;
  public masks: Masks;
  
  public listKits: KitMultiselectStruct[] = [];
  public listItems: ItemModel[] = [];

  public medicalProcedureStruct: MedicalProcedureStruct = null;
  public observationScheduling: ObservationScheduling;

  public isLoading: boolean = false;
  public firstLoading: boolean = true;
  public hasActionsButton: boolean = false;
  public buttonToSaveDisabled: boolean = false;

  public prescriptionType: number;
  public cycleTime: number;

  public startDateCycle: Date;

  ngOnInit(): void {
    this.firstLoading = false;
    this.model = this.formBuilder.group({
      listSchedulingDate: this.formBuilder.array([], { 
        validators: [dateHourInCrescentOrderValidator, minOneHourDifferenceValidator] }),
      observation: [""],
      listMaterials: this.formBuilder.array([]),
    });

    this.observationScheduling = this.data.observationScheduling;
    this.cycleTime = this.data.cycleTime;
    this.startDateCycle = this.data.startDateCycle;
    this.prescriptionType = this.data.prescriptionType;

    if(this.data && this.data.prescriptionItem) {
      this.medicalProcedureStruct = this.data.prescriptionItem;
      if(this.medicalProcedureStruct.isRecurring)
        this.hasActionsButton = true;
    }
    
    this.masks = this.maskService.getMasks();
    this.populateKitList();
    this.populateItemList();
    this.populate();
  }
  
  submit(){
    //colocar lógica de reaprazamento depois
    const listSchedulingDateForm = this.model.get('listSchedulingDate') as FormArray;

    if(listSchedulingDateForm.errors?.dateLessThanCurrentDate){
      this.alertService.show('Erro', "As datas não podem ser menores que a data de hoje!", AlertType.error);
      return;
    }
    if(this.model.invalid){
      return;
    }

    this.medicalProcedureStruct.listMedicalProcedureCheck = [];

    if (listSchedulingDateForm) {
      
      let inclusionDatePrescription = new Date(this.medicalProcedureStruct.datetimeInclusion);
      const firstDateValue = listSchedulingDateForm.at(0).get('date').value.toString();
      const firstHourValue = listSchedulingDateForm.at(0).value.hour.toString();
      if(!this.validFirstDate(firstDateValue, firstHourValue, inclusionDatePrescription)) {
        this.alertService.show('Erro', "Não é possível definir um horário inicial superior às 24h da criação da prescrição!", AlertType.error);
        return;
      }

      listSchedulingDateForm.getRawValue().forEach(x => {
        var medicalProcedureCheckStruct = new MedicalProcedureCheckStruct();
        
        let day = parseInt(x.date.substring(0, 2), 10);
        let month = parseInt(x.date.substring(2, 4), 10) - 1; // Mês é base zero
        let year = parseInt(x.date.substring(4), 10);
        let hour = parseInt(x.hour.substring(0, 2), 10);
        let minute = parseInt(x.hour.substring(2, 4), 10);

        medicalProcedureCheckStruct.datetimeCheckEstimative = new Date(year, month, day, hour, minute, 0);
        medicalProcedureCheckStruct.schedulingObservation = this.model.get('observation').value;
        medicalProcedureCheckStruct.idStatusScheduling = this.statusSchedulingEnum.Aprazado;
        this.medicalProcedureStruct.listMedicalProcedureCheck.push(medicalProcedureCheckStruct);
      });
    }
    if (this.model.get('listMaterials')) {
      this.medicalProcedureStruct.listMaterialItemKitRequests = [];
      this.model.get('listMaterials').value.forEach(x => {
        let requestItemKit = new MaterialItemKitRequests;
        requestItemKit.idRequestMaterialItemKit = x.idRequestMaterialItemKit;
        requestItemKit.idRequestMaterial = x.idRequestMaterial;
        let kitItem = x.kitItem.split('null')
        requestItemKit.idKit = kitItem[0] ? parseInt(kitItem[0]) : null;
        requestItemKit.idItem = kitItem[1] ? parseInt(kitItem[1]) : null;
        requestItemKit.quantity = x.quantity;
        if (requestItemKit.quantity <= 0) {
          this.alertService.show('Erro', "É necessário adicionar ao menos um item em cada material", AlertType.error);
          this.isLoading = false;
          return;
        }
        this.medicalProcedureStruct.listMaterialItemKitRequests.push(requestItemKit);
      });
    }
    this.matDialogRef.close({prescription: this.medicalProcedureStruct}); 
    
  }

  populate() {
    let listModelSchedulingDate = (this.model.controls['listSchedulingDate'] as FormArray);
    let listModelMaterials = (this.model.controls['listMaterials'] as FormArray);

    if(this.medicalProcedureStruct.listMedicalProcedureCheck
      && this.medicalProcedureStruct.listMedicalProcedureCheck.length > 0) {
        
      this.medicalProcedureStruct.listMedicalProcedureCheck.forEach(x => {
        x.datetimeCheckEstimative = new Date(x.datetimeCheckEstimative);
        listModelSchedulingDate.push(
          this.createInputDate(x.datetimeCheckEstimative)
        );
        if(x.idMedicalProcedureCheck != null)
          this.buttonToSaveDisabled = true;
      });
      this.model.get('observation').setValue(this.medicalProcedureStruct.listMedicalProcedureCheck[0].schedulingObservation);
      this.model.get('listSchedulingDate').updateValueAndValidity();
    } else {
      this.addNextInputDate();
    }
    
    //array de itens adicionais
    if(this.medicalProcedureStruct.listMaterialItemKitRequests) {
      this.medicalProcedureStruct.listMaterialItemKitRequests.forEach(x => {
        let idItem = x.idKit ? x.idKit + 'null' : 'null' + x.idItem;
        listModelMaterials.push(
          this.createInputMaterial(x, idItem)
        );
      });
    }
    this.model.get('listSchedulingDate').updateValueAndValidity();

  }

  close(){
    this.matDialogRef.close(); 
  }

  createInputDate(datetimeCheckEstimative?: Date) {
    if (datetimeCheckEstimative != null) {
      return this.formBuilder.group({
        date: [`${(datetimeCheckEstimative.getDate()).toString().padStart(2, '0')}${(datetimeCheckEstimative.getMonth()+1).toString().padStart(2, '0')}${datetimeCheckEstimative.getFullYear()}`, Validators.required],
        hour: [`${(datetimeCheckEstimative.getHours()).toString().padStart(2, '0')}${(datetimeCheckEstimative.getMinutes()).toString().padStart(2, '0')}`, Validators.required],
      });
    }
    else {
      return this.formBuilder.group({
        date: ['', Validators.required],
        hour: ['', Validators.required],
      });
    }
  }
  
  addNextInputDate() {
    (this.model.controls['listSchedulingDate'] as FormArray).push(this.createInputDate());
  }

  removeLastSchedulingDate() {
    const list = this.model.get('listSchedulingDate') as FormArray;
    if (list.length > 1) 
      list.removeAt(list.length - 1); 

    this.model.get('listSchedulingDate').updateValueAndValidity();
  }

  createInputMaterial(item?: MaterialItemKitRequests, idItem?: string) {
    if (item != null) {
      return this.formBuilder.group({
        kitItem: [idItem, [Validators.required]],
        quantity: [item.quantity, [Validators.required]],
        idRequestMaterialItemKit: [item.idRequestMaterialItemKit],
        idRequestMaterial: [item.idRequestMaterial]
      });
    }
    else {
      return this.formBuilder.group({
        kitItem: [null, [Validators.required]],
        quantity: [null, [Validators.required]],
        idRequestMaterialItemKit: [null],
        idRequestMaterial: [null]
      })
    }
  }
  
  addNextInputMaterial() {
    (this.model.controls['listMaterials'] as FormArray).push(this.createInputMaterial());
  }

  removeInputMaterial(index: number) {
    (this.model.controls['listMaterials'] as FormArray).removeAt(index);
    if (this.model.get('listMaterials')['controls'].length == 0 && index != 0)
      this.addNextInputMaterial();

  }
  
  openKit(kit: KitWithItemsStruct) {
    this.dialog.open(KitItemsModalComponent, {
      width: "700px",
      data: {
        kit: kit
      },
    });
  }

  populateKitList() {
    this.kitService.listAllKit().subscribe({
      next: (response) => {
        this.isLoading = false;
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }
        
        if(response.list && response.list.length > 0) {
          this.listKits = response.list;
        }
      },
      error: (error) => {
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  populateItemList() {
    this.itemService.listAllItem().subscribe({
      next: (response) => {
        this.isLoading = false;
        if (response.isError) {
          this.alertService.show('Erro', response.errorDescription, AlertType.error);
          return;
        }
        this.listItems = response.listItem;
      },
      error: (error) => {
        this.isLoading = false;
        this.alertService.show('Erro inesperado', error, AlertType.error);
      }
    });
  }

  validFirstDate(firstDateValue: string, firstHourValue: string, dateTimeInclusion: Date): boolean {
    const day = parseInt(firstDateValue.substring(0, 2), 10);
    const month = parseInt(firstDateValue.substring(2, 4), 10) - 1; // Mês é base zero
    const year = parseInt(firstDateValue.substring(4), 10);
    const hour = parseInt(firstHourValue.substring(0, 2), 10);
    const minute = parseInt(firstHourValue.substring(2, 4), 10);
    const firstDateInput = new Date(year, month, day, hour, minute, 0);
    dateTimeInclusion.setHours(dateTimeInclusion.getHours()+24)
    if(firstDateInput.getTime() < dateTimeInclusion.getTime())
      return true;
    else 
      return false;
  }
}